import type { ListingAgreementDetails } from '@urbanx/agx.campaigns.client';
import { toDateOnlyString, toExclusiveDate } from '@urbanx/agx.ui-components2';

import type { AppointmentPeriodValue } from './AppointmentPeriod';

export const updateAgreementDetailsAppointmentPeriod = (
  agreementDetails: ListingAgreementDetails,
  updated: Partial<AppointmentPeriodValue>
): ListingAgreementDetails =>
  ({
    ...agreementDetails,
    ...('startDate' in updated
      ? {
          startDate: updated.startDate ? toDateOnlyString(updated.startDate) : undefined,
        }
      : {}),
    ...('endDate' in updated
      ? {
          endDateExclusive: updated.endDate ? toExclusiveDate(updated.endDate) : undefined,
        }
      : {}),
  }) as ListingAgreementDetails;
